<template>
  <div>
    <div class="author-card">
      <md-avatar class="md-large">
        <img :src="user.avatar" :alt="name" />
      </md-avatar>

      <div class="author-card-info">
        <span>
          <b>{{ this.name }}</b>
        </span>
        <span>{{ this.user.email }}</span>
      </div>
    </div>
    <div>
      <div style="float: right;">
        <md-button @click="signOut" class="md-dense md-raised md-accent">Sign out</md-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "Profile",
  props: {
    user: Object
  },
  data() {
    return {};
  },
  computed: {
    name: function() {
      return this.user.first_name + " " + this.user.last_name;
    }
  },
  methods: {
    ...mapActions(["signOut"])
  }
};
</script>
<style lang="scss">
.author-card {
  padding: 8px 16px;
  display: flex;
  align-items: center;

  .md-avatar {
    margin-right: 16px;
  }

  .author-card-info {
    display: flex;
    flex-flow: column;
    flex: 1;
  }

  span {
    font-size: 16px;
  }

  .author-card-links {
    display: flex;

    a + a {
      margin-left: 8px;
    }
  }
}
</style>
